
<div class="row-custom">

  <div class="col-custom h-10">

    <ul class="nav nav-tabs not-selectable" >

      <li class="nav-item item-config">
        <a class="nav-link " (click)="changerTab(1)" [ngClass]="tab == 1 ? 'active':'' ">{{'KPI.KPI' | translate }}</a>
      </li>
      <li class="nav-item item-config ">
        <a class="nav-link" (click)="changerTab(2)" [ngClass]="tab == 2 ? 'active':'' "> {{'GLOBAL.VIBRATIONS' | translate }}</a>
        <!-- <a class="nav-link"  [ngClass]="tab == 2 ? 'active':'' "> {{'GLOBAL.VIBRATIONS' | translate }}</a> -->
      </li>

    </ul>

  </div>

  <div class="col-custom h-90">
    @if (tab == 1) {
      <app-plot-kpis></app-plot-kpis>
    }
    @if (tab == 2) {
      <app-plot-vibration></app-plot-vibration>
    }
  </div>
</div>
